import { PermissionGroup } from '../../models/Role/role.interface';

export const PERMISSIONS = {

  CONTACTS_LIST: 'contacts-list',
  CONTACTS_CREATE: 'contacts-create',
  CONTACTS_VIEW: 'contacts-view',
  CONTACTS_ADD_TO_PROJECT: 'contacts-add-to-project',
  CONTACTS_ADD_AS_SOURCE: 'contacts-add-as-source',

  COMPANIES_LIST: 'companies-list',
  COMPANIES_CREATE: 'companies-create',
  COMPANIES_VIEW: 'companies-view',
  COMPANIES_ADD_TO_PROJECT: 'companies-add-to-project',

  PROJECTS_LIST: 'projects-list',
  PROJECTS_CREATE: 'projects-create',
  PROJECTS_PITCH_DASHBOARD: 'projects-pitch-dashboard',
  PROJECTS_PROJECT_DASHBOARD: 'projects-project-dashboard',

  SETTINGS_ADMIN_USERS_LIST: 'settings-admin-users-list',
  SETTINGS_ADMIN_USERS_CREATE: 'settings-admin-users-create',
  SETTINGS_ADMIN_USERS_EDIT: 'settings-admin-users-edit',
  SETTINGS_ADMIN_USERS_DELETE: 'settings-admin-users-delete',

  SETTINGS_CLIENT_USERS_LIST: 'settings-client-users-list',
  SETTINGS_CLIENT_USERS_CREATE: 'settings-client-users-create',
  SETTINGS_CLIENT_USERS_EDIT: 'settings-client-users-edit',
  SETTINGS_CLIENT_USERS_DELETE: 'settings-client-users-delete',

  SETTINGS_ROLES_LIST: 'settings-roles-list',
  SETTINGS_ROLES_CREATE: 'settings-roles-create',
  SETTINGS_ROLES_EDIT: 'settings-roles-edit',
  SETTINGS_ROLES_DELETE: 'settings-roles-delete',

  SETTINGS_LISTS_LIST: 'settings-lists-list',
  SETTINGS_LISTS_CREATE: 'settings-lists-create',
  SETTINGS_LISTS_EDIT: 'settings-lists-edit',
  SETTINGS_LISTS_DELETE: 'settings-lists-delete',

} as const;

export const PERMISSION_GROUPS: PermissionGroup[] = [
  {
    category: 'Contacts Management',
    permissions: [
      { id: PERMISSIONS.CONTACTS_LIST, name: 'View contacts list' },
      { id: PERMISSIONS.CONTACTS_CREATE, name: 'Create contact' },
      { id: PERMISSIONS.CONTACTS_VIEW, name: 'View contact details' },
      { id: PERMISSIONS.CONTACTS_ADD_TO_PROJECT, name: 'Add contact to project' },
      { id: PERMISSIONS.CONTACTS_ADD_AS_SOURCE, name: 'Add contact as source' },
    ],
  },
  {
    category: 'Companies Management',
    permissions: [
      { id: PERMISSIONS.COMPANIES_LIST, name: 'View companies list' },
      { id: PERMISSIONS.COMPANIES_CREATE, name: 'Create company' },
      { id: PERMISSIONS.COMPANIES_VIEW, name: 'View company details' },
      { id: PERMISSIONS.COMPANIES_ADD_TO_PROJECT, name: 'Add company to project' },
    ],
  },
  {
    category: 'Projects Management',
    permissions: [
      { id: PERMISSIONS.PROJECTS_LIST, name: 'View projects list' },
      { id: PERMISSIONS.PROJECTS_CREATE, name: 'Create project' },
      { id: PERMISSIONS.PROJECTS_PITCH_DASHBOARD, name: 'Access pitch dashboard' },
      { id: PERMISSIONS.PROJECTS_PROJECT_DASHBOARD, name: 'Access project dashboard' },
    ],
  },
  {
    category: 'Settings - Manage Admin Users',
    permissions: [
      { id: PERMISSIONS.SETTINGS_ADMIN_USERS_LIST, name: 'View users list' },
      { id: PERMISSIONS.SETTINGS_ADMIN_USERS_CREATE, name: 'Create user' },
      { id: PERMISSIONS.SETTINGS_ADMIN_USERS_EDIT, name: 'Edit user' },
      { id: PERMISSIONS.SETTINGS_ADMIN_USERS_DELETE, name: 'Delete user' },
    ],
  },
  {
    category: 'Settings - Manage Admin Roles',
    permissions: [
      { id: PERMISSIONS.SETTINGS_ROLES_LIST, name: 'View roles list' },
      { id: PERMISSIONS.SETTINGS_ROLES_CREATE, name: 'Create role' },
      { id: PERMISSIONS.SETTINGS_ROLES_EDIT, name: 'Edit role' },
      { id: PERMISSIONS.SETTINGS_ROLES_DELETE, name: 'Delete role' },
    ],
  },
  {
    category: 'Settings - Manage Client Users',
    permissions: [
      { id: PERMISSIONS.SETTINGS_CLIENT_USERS_LIST, name: 'View client users list' },
      { id: PERMISSIONS.SETTINGS_CLIENT_USERS_CREATE, name: 'Create client user' },
      { id: PERMISSIONS.SETTINGS_CLIENT_USERS_EDIT, name: 'Edit client user' },
      { id: PERMISSIONS.SETTINGS_CLIENT_USERS_DELETE, name: 'Delete client user' },
    ],
  },
  {
    category: 'Settings - Manage Lists',
    permissions: [
      { id: PERMISSIONS.SETTINGS_LISTS_LIST, name: 'View lists' },
      { id: PERMISSIONS.SETTINGS_LISTS_CREATE, name: 'Create list' },
      { id: PERMISSIONS.SETTINGS_LISTS_EDIT, name: 'Edit list' },
      { id: PERMISSIONS.SETTINGS_LISTS_DELETE, name: 'Delete list' },
    ],
  },
];

export const getAllPermissionIds = (): string[] => {
  return Object.values(PERMISSIONS);
};

export const getPermissionName = (permissionId: string): string | undefined => {
  for (const group of PERMISSION_GROUPS) {
    const permission = group.permissions.find(p => p.id === permissionId);
    if (permission) {
      return permission.name;
    }
  }
  return undefined;
};

export const isValidPermission = (permissionId: string): boolean => {
  return getAllPermissionIds().includes(permissionId);
};
